var datas = [{
  "departement_name": "01 - Ain",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 482,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 69,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "01 - Ain",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 964,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 139,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "01 - Ain",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1446,
  "estimated_value": 3396,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 208,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "270€",
  "_1": "0,07€"
}, {
  "departement_name": "01 - Ain",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1928,
  "estimated_value": 4528,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 278,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "360€",
  "_1": "0,07€"
}, {
  "departement_name": "02 - Aisne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 429,
  "estimated_value": 1006,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 62,
  "kwh_network": "0,1821",
  "rentabilite": "7,4",
  "": "80€",
  "_1": "0,09€"
}, {
  "departement_name": "02 - Aisne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 858,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 123,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "02 - Aisne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1286,
  "estimated_value": 3019,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 185,
  "kwh_network": "0,1821",
  "rentabilite": "6,8",
  "": "240€",
  "_1": "0,08€"
}, {
  "departement_name": "02 - Aisne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1715,
  "estimated_value": 4025,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 247,
  "kwh_network": "0,1821",
  "rentabilite": "6,7",
  "": "320€",
  "_1": "0,08€"
}, {
  "departement_name": "03 - Allier",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 473,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 68,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "03 - Allier",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 946,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 136,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "03 - Allier",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1418,
  "estimated_value": 3270,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 204,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "260€",
  "_1": "0,07€"
}, {
  "departement_name": "03 - Allier",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1891,
  "estimated_value": 4402,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 272,
  "kwh_network": "0,1821",
  "rentabilite": "6,1",
  "": "350€",
  "_1": "0,07€"
}, {
  "departement_name": "04 - Alpes de Haute- Provence",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 614,
  "estimated_value": 1509,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 88,
  "kwh_network": "0,1821",
  "rentabilite": "5,0",
  "": "120€",
  "_1": "0,06€"
}, {
  "departement_name": "04 - Alpes de Haute- Provence",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1228,
  "estimated_value": 2893,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 177,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "230€",
  "_1": "0,06€"
}, {
  "departement_name": "04 - Alpes de Haute- Provence",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1842,
  "estimated_value": 4276,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 265,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "340€",
  "_1": "0,06€"
}, {
  "departement_name": "04 - Alpes de Haute- Provence",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2456,
  "estimated_value": 5660,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 354,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "450€",
  "_1": "0,05€"
}, {
  "departement_name": "05 - Hautes- Alpes",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 614,
  "estimated_value": 1509,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 88,
  "kwh_network": "0,1821",
  "rentabilite": "5,0",
  "": "120€",
  "_1": "0,06€"
}, {
  "departement_name": "05 - Hautes- Alpes",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1228,
  "estimated_value": 2893,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 177,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "230€",
  "_1": "0,06€"
}, {
  "departement_name": "05 - Hautes- Alpes",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1842,
  "estimated_value": 4276,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 265,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "340€",
  "_1": "0,06€"
}, {
  "departement_name": "05 - Hautes- Alpes",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2456,
  "estimated_value": 5660,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 354,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "450€",
  "_1": "0,05€"
}, {
  "departement_name": "06 - Alpes- Maritimes",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 618,
  "estimated_value": 1509,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 89,
  "kwh_network": "0,1821",
  "rentabilite": "5,0",
  "": "120€",
  "_1": "0,06€"
}, {
  "departement_name": "06 - Alpes- Maritimes",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1236,
  "estimated_value": 2893,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 178,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "230€",
  "_1": "0,06€"
}, {
  "departement_name": "06 - Alpes- Maritimes",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1854,
  "estimated_value": 4276,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 267,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "340€",
  "_1": "0,06€"
}, {
  "departement_name": "06 - Alpes- Maritimes",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2472,
  "estimated_value": 5786,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 356,
  "kwh_network": "0,1821",
  "rentabilite": "4,7",
  "": "460€",
  "_1": "0,05€"
}, {
  "departement_name": "07 - Ardèche",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 562,
  "estimated_value": 1384,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 81,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "110€",
  "_1": "0,07€"
}, {
  "departement_name": "07 - Ardèche",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1123,
  "estimated_value": 2641,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 162,
  "kwh_network": "0,1821",
  "rentabilite": "5,3",
  "": "210€",
  "_1": "0,06€"
}, {
  "departement_name": "07 - Ardèche",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1685,
  "estimated_value": 3899,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 243,
  "kwh_network": "0,1821",
  "rentabilite": "5,2",
  "": "310€",
  "_1": "0,06€"
}, {
  "departement_name": "07 - Ardèche",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2246,
  "estimated_value": 5157,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 323,
  "kwh_network": "0,1821",
  "rentabilite": "5,2",
  "": "410€",
  "_1": "0,06€"
}, {
  "departement_name": "09 - Ariège",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 549,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 79,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "09 - Ariège",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1098,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 158,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,06€"
}, {
  "departement_name": "09 - Ariège",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1646,
  "estimated_value": 3773,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 237,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "300€",
  "_1": "0,06€"
}, {
  "departement_name": "09 - Ariège",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2195,
  "estimated_value": 5031,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 316,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "400€",
  "_1": "0,06€"
}, {
  "departement_name": "10 - Aube",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 426,
  "estimated_value": 1006,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 61,
  "kwh_network": "0,1821",
  "rentabilite": "7,4",
  "": "80€",
  "_1": "0,09€"
}, {
  "departement_name": "10 - Aube",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 853,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 123,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "10 - Aube",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1279,
  "estimated_value": 3019,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 184,
  "kwh_network": "0,1821",
  "rentabilite": "6,8",
  "": "240€",
  "_1": "0,08€"
}, {
  "departement_name": "10 - Aube",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1706,
  "estimated_value": 4025,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 246,
  "kwh_network": "0,1821",
  "rentabilite": "6,7",
  "": "320€",
  "_1": "0,08€"
}, {
  "departement_name": "11 - Aude",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 529,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 76,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "11 - Aude",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1058,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 152,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,07€"
}, {
  "departement_name": "11 - Aude",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1586,
  "estimated_value": 3648,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 228,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "290€",
  "_1": "0,06€"
}, {
  "departement_name": "11 - Aude",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2115,
  "estimated_value": 4905,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 305,
  "kwh_network": "0,1821",
  "rentabilite": "5,5",
  "": "390€",
  "_1": "0,06€"
}, {
  "departement_name": "12 - Aveyron",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 544,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 78,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "12 - Aveyron",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1087,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 157,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,06€"
}, {
  "departement_name": "12 - Aveyron",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1631,
  "estimated_value": 3773,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 235,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "300€",
  "_1": "0,06€"
}, {
  "departement_name": "12 - Aveyron",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2174,
  "estimated_value": 5031,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 313,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "400€",
  "_1": "0,06€"
}, {
  "departement_name": "13 - Bouches du Rhône",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 616,
  "estimated_value": 1509,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 89,
  "kwh_network": "0,1821",
  "rentabilite": "5,0",
  "": "120€",
  "_1": "0,06€"
}, {
  "departement_name": "13 - Bouches du Rhône",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1231,
  "estimated_value": 2893,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 177,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "230€",
  "_1": "0,06€"
}, {
  "departement_name": "13 - Bouches du Rhône",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1847,
  "estimated_value": 4276,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 266,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "340€",
  "_1": "0,06€"
}, {
  "departement_name": "13 - Bouches du Rhône",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2462,
  "estimated_value": 5660,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 355,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "450€",
  "_1": "0,05€"
}, {
  "departement_name": "14 - Calvados",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 455,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 66,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "14 - Calvados",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 910,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 131,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "14 - Calvados",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1366,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 197,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,07€"
}, {
  "departement_name": "14 - Calvados",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1821,
  "estimated_value": 4276,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 262,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "340€",
  "_1": "0,07€"
}, {
  "departement_name": "15 - Cantal",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 453,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 65,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "15 - Cantal",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 906,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 131,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "15 - Cantal",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1360,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 196,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "15 - Cantal",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1813,
  "estimated_value": 4276,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 261,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "340€",
  "_1": "0,07€"
}, {
  "departement_name": "16 - Charente",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 535,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 77,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "16 - Charente",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1070,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 154,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,07€"
}, {
  "departement_name": "16 - Charente",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1604,
  "estimated_value": 3773,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 231,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "300€",
  "_1": "0,06€"
}, {
  "departement_name": "16 - Charente",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2139,
  "estimated_value": 4905,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 308,
  "kwh_network": "0,1821",
  "rentabilite": "5,5",
  "": "390€",
  "_1": "0,06€"
}, {
  "departement_name": "17 - Charente Maritime",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 535,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 77,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "17 - Charente Maritime",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1070,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 154,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,07€"
}, {
  "departement_name": "17 - Charente Maritime",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1604,
  "estimated_value": 3773,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 231,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "300€",
  "_1": "0,06€"
}, {
  "departement_name": "17 - Charente Maritime",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2139,
  "estimated_value": 4905,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 308,
  "kwh_network": "0,1821",
  "rentabilite": "5,5",
  "": "390€",
  "_1": "0,06€"
}, {
  "departement_name": "18 - Cher",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 462,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 67,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "18 - Cher",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 925,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 133,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "18 - Cher",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1387,
  "estimated_value": 3270,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 200,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "260€",
  "_1": "0,07€"
}, {
  "departement_name": "18 - Cher",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1850,
  "estimated_value": 4276,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 266,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "340€",
  "_1": "0,07€"
}, {
  "departement_name": "19 - Corrèze",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 500,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 72,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "19 - Corrèze",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 999,
  "estimated_value": 2390,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 144,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "190€",
  "_1": "0,07€"
}, {
  "departement_name": "19 - Corrèze",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1499,
  "estimated_value": 3522,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 216,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "280€",
  "_1": "0,07€"
}, {
  "departement_name": "19 - Corrèze",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1998,
  "estimated_value": 4654,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 288,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "370€",
  "_1": "0,07€"
}, {
  "departement_name": "21 - Côte d'Or",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 471,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 68,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "21 - Côte d'Or",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 942,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 136,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "21 - Côte d'Or",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1412,
  "estimated_value": 3270,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 203,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "260€",
  "_1": "0,07€"
}, {
  "departement_name": "21 - Côte d'Or",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1883,
  "estimated_value": 4402,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 271,
  "kwh_network": "0,1821",
  "rentabilite": "6,1",
  "": "350€",
  "_1": "0,07€"
}, {
  "departement_name": "22 - Côtes d'Armor",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 474,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 68,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "22 - Côtes d'Armor",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 948,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 137,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "22 - Côtes d'Armor",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1422,
  "estimated_value": 3270,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 205,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "260€",
  "_1": "0,07€"
}, {
  "departement_name": "22 - Côtes d'Armor",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1896,
  "estimated_value": 4402,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 273,
  "kwh_network": "0,1821",
  "rentabilite": "6,1",
  "": "350€",
  "_1": "0,07€"
}, {
  "departement_name": "23 - Creuse",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 500,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 72,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "23 - Creuse",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 999,
  "estimated_value": 2390,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 144,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "190€",
  "_1": "0,07€"
}, {
  "departement_name": "23 - Creuse",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1499,
  "estimated_value": 3522,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 216,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "280€",
  "_1": "0,07€"
}, {
  "departement_name": "23 - Creuse",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1998,
  "estimated_value": 4654,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 288,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "370€",
  "_1": "0,07€"
}, {
  "departement_name": "24 - Dordogne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 535,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 77,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "24 - Dordogne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1070,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 154,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,07€"
}, {
  "departement_name": "24 - Dordogne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1604,
  "estimated_value": 3773,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 231,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "300€",
  "_1": "0,06€"
}, {
  "departement_name": "24 - Dordogne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2139,
  "estimated_value": 4905,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 308,
  "kwh_network": "0,1821",
  "rentabilite": "5,5",
  "": "390€",
  "_1": "0,06€"
}, {
  "departement_name": "25 - Doubs",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 479,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 69,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "25 - Doubs",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 958,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 138,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "25 - Doubs",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1436,
  "estimated_value": 3396,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 207,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "270€",
  "_1": "0,07€"
}, {
  "departement_name": "25 - Doubs",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1915,
  "estimated_value": 4402,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 276,
  "kwh_network": "0,1821",
  "rentabilite": "6,1",
  "": "350€",
  "_1": "0,07€"
}, {
  "departement_name": "26 - Drôme",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 562,
  "estimated_value": 1384,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 81,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "110€",
  "_1": "0,07€"
}, {
  "departement_name": "26 - Drôme",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1123,
  "estimated_value": 2641,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 162,
  "kwh_network": "0,1821",
  "rentabilite": "5,3",
  "": "210€",
  "_1": "0,06€"
}, {
  "departement_name": "26 - Drôme",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1685,
  "estimated_value": 3899,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 243,
  "kwh_network": "0,1821",
  "rentabilite": "5,2",
  "": "310€",
  "_1": "0,06€"
}, {
  "departement_name": "26 - Drôme",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2246,
  "estimated_value": 5157,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 323,
  "kwh_network": "0,1821",
  "rentabilite": "5,2",
  "": "410€",
  "_1": "0,06€"
}, {
  "departement_name": "27 - Eure",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 444,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 64,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "27 - Eure",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 840,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 121,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "27 - Eure",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1260,
  "estimated_value": 2893,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 181,
  "kwh_network": "0,1821",
  "rentabilite": "7,1",
  "": "230€",
  "_1": "0,08€"
}, {
  "departement_name": "27 - Eure",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1680,
  "estimated_value": 3899,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 242,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "310€",
  "_1": "0,08€"
}, {
  "departement_name": "28 - Eure- et- Loir",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 444,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 64,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "28 - Eure- et- Loir",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 888,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 128,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "28 - Eure- et- Loir",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1332,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 192,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "28 - Eure- et- Loir",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1776,
  "estimated_value": 4151,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 256,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "330€",
  "_1": "0,08€"
}, {
  "departement_name": "29 - Finistère",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 462,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 67,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "29 - Finistère",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 924,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 133,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "29 - Finistère",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1386,
  "estimated_value": 3270,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 200,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "260€",
  "_1": "0,07€"
}, {
  "departement_name": "29 - Finistère",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1848,
  "estimated_value": 4276,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 266,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "340€",
  "_1": "0,07€"
}, {
  "departement_name": "2A - Haute Corse",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 624,
  "estimated_value": 1509,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 90,
  "kwh_network": "0,1821",
  "rentabilite": "5,0",
  "": "120€",
  "_1": "0,06€"
}, {
  "departement_name": "2A - Haute Corse",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1249,
  "estimated_value": 2893,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 180,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "230€",
  "_1": "0,06€"
}, {
  "departement_name": "2A - Haute Corse",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1873,
  "estimated_value": 4402,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 270,
  "kwh_network": "0,1821",
  "rentabilite": "4,6",
  "": "350€",
  "_1": "0,05€"
}, {
  "departement_name": "2A - Haute Corse",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2498,
  "estimated_value": 5786,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 360,
  "kwh_network": "0,1821",
  "rentabilite": "4,7",
  "": "460€",
  "_1": "0,05€"
}, {
  "departement_name": "2B - Corse du Sud",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 646,
  "estimated_value": 1509,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 93,
  "kwh_network": "0,1821",
  "rentabilite": "5,0",
  "": "120€",
  "_1": "0,06€"
}, {
  "departement_name": "2B - Corse du Sud",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1292,
  "estimated_value": 3019,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 186,
  "kwh_network": "0,1821",
  "rentabilite": "4,6",
  "": "240€",
  "_1": "0,05€"
}, {
  "departement_name": "2B - Corse du Sud",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1938,
  "estimated_value": 4528,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 279,
  "kwh_network": "0,1821",
  "rentabilite": "4,5",
  "": "360€",
  "_1": "0,05€"
}, {
  "departement_name": "2B - Corse du Sud",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2584,
  "estimated_value": 6037,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 372,
  "kwh_network": "0,1821",
  "rentabilite": "4,5",
  "": "480€",
  "_1": "0,05€"
}, {
  "departement_name": "30 - Gard",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 621,
  "estimated_value": 1509,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 89,
  "kwh_network": "0,1821",
  "rentabilite": "5,0",
  "": "120€",
  "_1": "0,06€"
}, {
  "departement_name": "30 - Gard",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1242,
  "estimated_value": 2893,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 179,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "230€",
  "_1": "0,06€"
}, {
  "departement_name": "30 - Gard",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1864,
  "estimated_value": 4276,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 268,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "340€",
  "_1": "0,05€"
}, {
  "departement_name": "30 - Gard",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2485,
  "estimated_value": 5786,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 358,
  "kwh_network": "0,1821",
  "rentabilite": "4,7",
  "": "460€",
  "_1": "0,05€"
}, {
  "departement_name": "31 - Haute- Garonne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 549,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 79,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "31 - Haute- Garonne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1098,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 158,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,06€"
}, {
  "departement_name": "31 - Haute- Garonne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1646,
  "estimated_value": 3773,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 237,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "300€",
  "_1": "0,06€"
}, {
  "departement_name": "31 - Haute- Garonne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2195,
  "estimated_value": 5031,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 316,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "400€",
  "_1": "0,06€"
}, {
  "departement_name": "32 - Gers",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 549,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 79,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "32 - Gers",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1098,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 158,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,06€"
}, {
  "departement_name": "32 - Gers",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1646,
  "estimated_value": 3773,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 237,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "300€",
  "_1": "0,06€"
}, {
  "departement_name": "32 - Gers",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2195,
  "estimated_value": 5031,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 316,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "400€",
  "_1": "0,06€"
}, {
  "departement_name": "33 - Gironde",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 549,
  "estimated_value": 1384,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 79,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "110€",
  "_1": "0,07€"
}, {
  "departement_name": "33 - Gironde",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1098,
  "estimated_value": 2641,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 158,
  "kwh_network": "0,1821",
  "rentabilite": "5,3",
  "": "210€",
  "_1": "0,06€"
}, {
  "departement_name": "33 - Gironde",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1648,
  "estimated_value": 3899,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 237,
  "kwh_network": "0,1821",
  "rentabilite": "5,2",
  "": "310€",
  "_1": "0,06€"
}, {
  "departement_name": "33 - Gironde",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2197,
  "estimated_value": 5157,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 316,
  "kwh_network": "0,1821",
  "rentabilite": "5,2",
  "": "410€",
  "_1": "0,06€"
}, {
  "departement_name": "34 - Hérault",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 596,
  "estimated_value": 1384,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 86,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "110€",
  "_1": "0,06€"
}, {
  "departement_name": "34 - Hérault",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1192,
  "estimated_value": 2767,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 172,
  "kwh_network": "0,1821",
  "rentabilite": "5,1",
  "": "220€",
  "_1": "0,06€"
}, {
  "departement_name": "34 - Hérault",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1788,
  "estimated_value": 4151,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 257,
  "kwh_network": "0,1821",
  "rentabilite": "4,9",
  "": "330€",
  "_1": "0,06€"
}, {
  "departement_name": "34 - Hérault",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2384,
  "estimated_value": 5534,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 343,
  "kwh_network": "0,1821",
  "rentabilite": "4,9",
  "": "440€",
  "_1": "0,06€"
}, {
  "departement_name": "35 - Ille- et- Vilaine",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 474,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 68,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "35 - Ille- et- Vilaine",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 948,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 137,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "35 - Ille- et- Vilaine",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1422,
  "estimated_value": 3270,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 205,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "260€",
  "_1": "0,07€"
}, {
  "departement_name": "35 - Ille- et- Vilaine",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1896,
  "estimated_value": 4402,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 273,
  "kwh_network": "0,1821",
  "rentabilite": "6,1",
  "": "350€",
  "_1": "0,07€"
}, {
  "departement_name": "36 - Indre",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 490,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 71,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "36 - Indre",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 981,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 141,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "36 - Indre",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1471,
  "estimated_value": 3396,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 212,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "270€",
  "_1": "0,07€"
}, {
  "departement_name": "36 - Indre",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1962,
  "estimated_value": 4528,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 282,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "360€",
  "_1": "0,07€"
}, {
  "departement_name": "37 - Indre- et- Loire",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 506,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 73,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "37 - Indre- et- Loire",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1011,
  "estimated_value": 2390,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 146,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "190€",
  "_1": "0,07€"
}, {
  "departement_name": "37 - Indre- et- Loire",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1517,
  "estimated_value": 3522,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 218,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "280€",
  "_1": "0,07€"
}, {
  "departement_name": "37 - Indre- et- Loire",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2022,
  "estimated_value": 4654,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 291,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "370€",
  "_1": "0,07€"
}, {
  "departement_name": "38 - Isère",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 536,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 77,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "38 - Isère",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1071,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 154,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,07€"
}, {
  "departement_name": "38 - Isère",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1607,
  "estimated_value": 3773,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 231,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "300€",
  "_1": "0,06€"
}, {
  "departement_name": "38 - Isère",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2142,
  "estimated_value": 5031,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 309,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "400€",
  "_1": "0,06€"
}, {
  "departement_name": "39 - Jura",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 485,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 70,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "39 - Jura",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 970,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 140,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "39 - Jura",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1454,
  "estimated_value": 3396,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 209,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "270€",
  "_1": "0,07€"
}, {
  "departement_name": "39 - Jura",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1939,
  "estimated_value": 4528,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 279,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "360€",
  "_1": "0,07€"
}, {
  "departement_name": "40 - Landes",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 549,
  "estimated_value": 1384,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 79,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "110€",
  "_1": "0,07€"
}, {
  "departement_name": "40 - Landes",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1098,
  "estimated_value": 2641,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 158,
  "kwh_network": "0,1821",
  "rentabilite": "5,3",
  "": "210€",
  "_1": "0,06€"
}, {
  "departement_name": "40 - Landes",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1648,
  "estimated_value": 3899,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 237,
  "kwh_network": "0,1821",
  "rentabilite": "5,2",
  "": "310€",
  "_1": "0,06€"
}, {
  "departement_name": "40 - Landes",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2197,
  "estimated_value": 5157,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 316,
  "kwh_network": "0,1821",
  "rentabilite": "5,2",
  "": "410€",
  "_1": "0,06€"
}, {
  "departement_name": "41 - Loir- et- Cher",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 498,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 72,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,08€"
}, {
  "departement_name": "41 - Loir- et- Cher",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 996,
  "estimated_value": 2390,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 143,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "190€",
  "_1": "0,07€"
}, {
  "departement_name": "41 - Loir- et- Cher",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1494,
  "estimated_value": 3522,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 215,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "280€",
  "_1": "0,07€"
}, {
  "departement_name": "41 - Loir- et- Cher",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1992,
  "estimated_value": 4654,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 287,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "370€",
  "_1": "0,07€"
}, {
  "departement_name": "42 - Loire",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 488,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 70,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "42 - Loire",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 975,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 140,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "42 - Loire",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1463,
  "estimated_value": 3396,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 211,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "270€",
  "_1": "0,07€"
}, {
  "departement_name": "42 - Loire",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1950,
  "estimated_value": 4528,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 281,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "360€",
  "_1": "0,07€"
}, {
  "departement_name": "43 - Haute- Loire",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 453,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 65,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "43 - Haute- Loire",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 906,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 131,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "43 - Haute- Loire",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1360,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 196,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "43 - Haute- Loire",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1813,
  "estimated_value": 4276,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 261,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "340€",
  "_1": "0,07€"
}, {
  "departement_name": "44 - Loire- Atlantique",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 503,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 72,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "44 - Loire- Atlantique",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1006,
  "estimated_value": 2390,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 145,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "190€",
  "_1": "0,07€"
}, {
  "departement_name": "44 - Loire- Atlantique",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1508,
  "estimated_value": 3522,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 217,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "280€",
  "_1": "0,07€"
}, {
  "departement_name": "44 - Loire- Atlantique",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2011,
  "estimated_value": 4654,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 290,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "370€",
  "_1": "0,07€"
}, {
  "departement_name": "45 - Loiret",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 498,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 72,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,08€"
}, {
  "departement_name": "45 - Loiret",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 996,
  "estimated_value": 2390,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 143,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "190€",
  "_1": "0,07€"
}, {
  "departement_name": "45 - Loiret",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1494,
  "estimated_value": 3522,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 215,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "280€",
  "_1": "0,07€"
}, {
  "departement_name": "45 - Loiret",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1992,
  "estimated_value": 4654,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 287,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "370€",
  "_1": "0,07€"
}, {
  "departement_name": "46 - Lot",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 530,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 76,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "46 - Lot",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1061,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 153,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,07€"
}, {
  "departement_name": "46 - Lot",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1591,
  "estimated_value": 3648,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 229,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "290€",
  "_1": "0,06€"
}, {
  "departement_name": "46 - Lot",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2122,
  "estimated_value": 4905,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 306,
  "kwh_network": "0,1821",
  "rentabilite": "5,5",
  "": "390€",
  "_1": "0,06€"
}, {
  "departement_name": "47 - Lot- et- Garonne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 523,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 75,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "47 - Lot- et- Garonne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1046,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 151,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,07€"
}, {
  "departement_name": "47 - Lot- et- Garonne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1570,
  "estimated_value": 3648,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 226,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "290€",
  "_1": "0,07€"
}, {
  "departement_name": "47 - Lot- et- Garonne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2093,
  "estimated_value": 4905,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 301,
  "kwh_network": "0,1821",
  "rentabilite": "5,5",
  "": "390€",
  "_1": "0,06€"
}, {
  "departement_name": "48 - Lozère",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 562,
  "estimated_value": 1384,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 81,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "110€",
  "_1": "0,07€"
}, {
  "departement_name": "48 - Lozère",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1123,
  "estimated_value": 2641,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 162,
  "kwh_network": "0,1821",
  "rentabilite": "5,3",
  "": "210€",
  "_1": "0,06€"
}, {
  "departement_name": "48 - Lozère",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1685,
  "estimated_value": 3899,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 243,
  "kwh_network": "0,1821",
  "rentabilite": "5,2",
  "": "310€",
  "_1": "0,06€"
}, {
  "departement_name": "48 - Lozère",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2246,
  "estimated_value": 5157,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 323,
  "kwh_network": "0,1821",
  "rentabilite": "5,2",
  "": "410€",
  "_1": "0,06€"
}, {
  "departement_name": "49 - Maine- et- Loire",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 494,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 71,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "49 - Maine- et- Loire",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 988,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 142,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "49 - Maine- et- Loire",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1482,
  "estimated_value": 3396,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 213,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "270€",
  "_1": "0,07€"
}, {
  "departement_name": "49 - Maine- et- Loire",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1976,
  "estimated_value": 4528,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 285,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "360€",
  "_1": "0,07€"
}, {
  "departement_name": "50 - Manche",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 455,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 66,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "50 - Manche",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 910,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 131,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "50 - Manche",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1366,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 197,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,07€"
}, {
  "departement_name": "50 - Manche",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1821,
  "estimated_value": 4276,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 262,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "340€",
  "_1": "0,07€"
}, {
  "departement_name": "51 - Marne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 439,
  "estimated_value": 1006,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 63,
  "kwh_network": "0,1821",
  "rentabilite": "7,4",
  "": "80€",
  "_1": "0,09€"
}, {
  "departement_name": "51 - Marne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 878,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 126,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "51 - Marne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1318,
  "estimated_value": 3019,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 190,
  "kwh_network": "0,1821",
  "rentabilite": "6,8",
  "": "240€",
  "_1": "0,08€"
}, {
  "departement_name": "51 - Marne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1757,
  "estimated_value": 4025,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 253,
  "kwh_network": "0,1821",
  "rentabilite": "6,7",
  "": "320€",
  "_1": "0,08€"
}, {
  "departement_name": "52 - Haute- Marne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 441,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 63,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "52 - Haute- Marne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 882,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 127,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "52 - Haute- Marne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1322,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 190,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "52 - Haute- Marne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1763,
  "estimated_value": 4151,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 254,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "330€",
  "_1": "0,08€"
}, {
  "departement_name": "53 - Mayenne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 430,
  "estimated_value": 1006,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 62,
  "kwh_network": "0,1821",
  "rentabilite": "7,4",
  "": "80€",
  "_1": "0,09€"
}, {
  "departement_name": "53 - Mayenne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 861,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 124,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "53 - Mayenne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1291,
  "estimated_value": 3019,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 186,
  "kwh_network": "0,1821",
  "rentabilite": "6,8",
  "": "240€",
  "_1": "0,08€"
}, {
  "departement_name": "53 - Mayenne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1722,
  "estimated_value": 4025,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 248,
  "kwh_network": "0,1821",
  "rentabilite": "6,7",
  "": "320€",
  "_1": "0,08€"
}, {
  "departement_name": "54 - Meurthe- et- Moselle",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 453,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 65,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "54 - Meurthe- et- Moselle",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 906,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 131,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "54 - Meurthe- et- Moselle",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1360,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 196,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "54 - Meurthe- et- Moselle",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1813,
  "estimated_value": 4276,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 261,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "340€",
  "_1": "0,07€"
}, {
  "departement_name": "55 - Meuse",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 429,
  "estimated_value": 1006,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 62,
  "kwh_network": "0,1821",
  "rentabilite": "7,4",
  "": "80€",
  "_1": "0,09€"
}, {
  "departement_name": "55 - Meuse",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 858,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 123,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "55 - Meuse",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1286,
  "estimated_value": 3019,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 185,
  "kwh_network": "0,1821",
  "rentabilite": "6,8",
  "": "240€",
  "_1": "0,08€"
}, {
  "departement_name": "55 - Meuse",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1715,
  "estimated_value": 4025,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 247,
  "kwh_network": "0,1821",
  "rentabilite": "6,7",
  "": "320€",
  "_1": "0,08€"
}, {
  "departement_name": "56 - Morbihan",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 503,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 72,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "56 - Morbihan",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1006,
  "estimated_value": 2390,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 145,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "190€",
  "_1": "0,07€"
}, {
  "departement_name": "56 - Morbihan",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1508,
  "estimated_value": 3522,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 217,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "280€",
  "_1": "0,07€"
}, {
  "departement_name": "56 - Morbihan",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2011,
  "estimated_value": 4654,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 290,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "370€",
  "_1": "0,07€"
}, {
  "departement_name": "57 - Moselle",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 447,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 64,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "57 - Moselle",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 894,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 129,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "57 - Moselle",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1340,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 193,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "57 - Moselle",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1787,
  "estimated_value": 4151,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 257,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "330€",
  "_1": "0,08€"
}, {
  "departement_name": "58 - Nièvre",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 475,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 68,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "58 - Nièvre",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 950,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 137,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "58 - Nièvre",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1424,
  "estimated_value": 3270,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 205,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "260€",
  "_1": "0,07€"
}, {
  "departement_name": "58 - Nièvre",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1899,
  "estimated_value": 4402,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 273,
  "kwh_network": "0,1821",
  "rentabilite": "6,1",
  "": "350€",
  "_1": "0,07€"
}, {
  "departement_name": "59 - Nord",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 422,
  "estimated_value": 1006,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 61,
  "kwh_network": "0,1821",
  "rentabilite": "7,4",
  "": "80€",
  "_1": "0,09€"
}, {
  "departement_name": "59 - Nord",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 845,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 122,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "59 - Nord",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1267,
  "estimated_value": 3019,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 182,
  "kwh_network": "0,1821",
  "rentabilite": "6,8",
  "": "240€",
  "_1": "0,08€"
}, {
  "departement_name": "59 - Nord",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1690,
  "estimated_value": 3899,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 243,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "310€",
  "_1": "0,08€"
}, {
  "departement_name": "60 - Oise",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 447,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 64,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "60 - Oise",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 894,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 129,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "60 - Oise",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1340,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 193,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "60 - Oise",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1787,
  "estimated_value": 4151,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 257,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "330€",
  "_1": "0,08€"
}, {
  "departement_name": "61 - Orne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 430,
  "estimated_value": 1006,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 62,
  "kwh_network": "0,1821",
  "rentabilite": "7,4",
  "": "80€",
  "_1": "0,09€"
}, {
  "departement_name": "61 - Orne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 861,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 124,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "61 - Orne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1291,
  "estimated_value": 3019,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 186,
  "kwh_network": "0,1821",
  "rentabilite": "6,8",
  "": "240€",
  "_1": "0,08€"
}, {
  "departement_name": "61 - Orne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1722,
  "estimated_value": 4025,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 248,
  "kwh_network": "0,1821",
  "rentabilite": "6,7",
  "": "320€",
  "_1": "0,08€"
}, {
  "departement_name": "62 - Pas- de- Calais",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 422,
  "estimated_value": 1006,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 61,
  "kwh_network": "0,1821",
  "rentabilite": "7,4",
  "": "80€",
  "_1": "0,09€"
}, {
  "departement_name": "62 - Pas- de- Calais",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 845,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 122,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "62 - Pas- de- Calais",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1267,
  "estimated_value": 3019,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 182,
  "kwh_network": "0,1821",
  "rentabilite": "6,8",
  "": "240€",
  "_1": "0,08€"
}, {
  "departement_name": "62 - Pas- de- Calais",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1690,
  "estimated_value": 3899,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 243,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "310€",
  "_1": "0,08€"
}, {
  "departement_name": "63 - Puy- de- Dôme",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 490,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 71,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "63 - Puy- de- Dôme",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 980,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 141,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "63 - Puy- de- Dôme",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1470,
  "estimated_value": 3396,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 212,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "270€",
  "_1": "0,07€"
}, {
  "departement_name": "63 - Puy- de- Dôme",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1960,
  "estimated_value": 4528,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 282,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "360€",
  "_1": "0,07€"
}, {
  "departement_name": "64 - Pyrénées- Atlantiques",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 528,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 76,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "64 - Pyrénées- Atlantiques",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1055,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 152,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,07€"
}, {
  "departement_name": "64 - Pyrénées- Atlantiques",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1583,
  "estimated_value": 3648,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 228,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "290€",
  "_1": "0,06€"
}, {
  "departement_name": "64 - Pyrénées- Atlantiques",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2110,
  "estimated_value": 4905,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 304,
  "kwh_network": "0,1821",
  "rentabilite": "5,5",
  "": "390€",
  "_1": "0,06€"
}, {
  "departement_name": "65 - Hautes- Pyrénées",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 549,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 79,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "65 - Hautes- Pyrénées",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1098,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 158,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,06€"
}, {
  "departement_name": "65 - Hautes- Pyrénées",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1646,
  "estimated_value": 3773,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 237,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "300€",
  "_1": "0,06€"
}, {
  "departement_name": "65 - Hautes- Pyrénées",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2195,
  "estimated_value": 5031,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 316,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "400€",
  "_1": "0,06€"
}, {
  "departement_name": "66 - Pyrénées- Orientales",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 612,
  "estimated_value": 1509,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 88,
  "kwh_network": "0,1821",
  "rentabilite": "5,0",
  "": "120€",
  "_1": "0,06€"
}, {
  "departement_name": "66 - Pyrénées- Orientales",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1225,
  "estimated_value": 2893,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 176,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "230€",
  "_1": "0,06€"
}, {
  "departement_name": "66 - Pyrénées- Orientales",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1837,
  "estimated_value": 4276,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 265,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "340€",
  "_1": "0,06€"
}, {
  "departement_name": "66 - Pyrénées- Orientales",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2450,
  "estimated_value": 5660,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 353,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "450€",
  "_1": "0,06€"
}, {
  "departement_name": "67 - Bas- Rhin",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 436,
  "estimated_value": 1006,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 63,
  "kwh_network": "0,1821",
  "rentabilite": "7,4",
  "": "80€",
  "_1": "0,09€"
}, {
  "departement_name": "67 - Bas- Rhin",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 873,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 126,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "67 - Bas- Rhin",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1309,
  "estimated_value": 3019,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 189,
  "kwh_network": "0,1821",
  "rentabilite": "6,8",
  "": "240€",
  "_1": "0,08€"
}, {
  "departement_name": "67 - Bas- Rhin",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1746,
  "estimated_value": 4025,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 251,
  "kwh_network": "0,1821",
  "rentabilite": "6,7",
  "": "320€",
  "_1": "0,08€"
}, {
  "departement_name": "68 - Haut- Rhin",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 458,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 66,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "68 - Haut- Rhin",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 915,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 132,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "68 - Haut- Rhin",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1373,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 198,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,07€"
}, {
  "departement_name": "68 - Haut- Rhin",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1830,
  "estimated_value": 4276,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 264,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "340€",
  "_1": "0,07€"
}, {
  "departement_name": "69 - Rhône",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 501,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 72,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "69 - Rhône",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1002,
  "estimated_value": 2390,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 144,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "190€",
  "_1": "0,07€"
}, {
  "departement_name": "69 - Rhône",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1502,
  "estimated_value": 3522,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 216,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "280€",
  "_1": "0,07€"
}, {
  "departement_name": "69 - Rhône",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2003,
  "estimated_value": 4654,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 288,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "370€",
  "_1": "0,07€"
}, {
  "departement_name": "70 - Haute- Saône",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 461,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 66,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "70 - Haute- Saône",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 922,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 133,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "70 - Haute- Saône",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1384,
  "estimated_value": 3270,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 199,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "260€",
  "_1": "0,07€"
}, {
  "departement_name": "70 - Haute- Saône",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1845,
  "estimated_value": 4276,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 266,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "340€",
  "_1": "0,07€"
}, {
  "departement_name": "71 - Saône- et- Loire",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 482,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 69,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "71 - Saône- et- Loire",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 964,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 139,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "71 - Saône- et- Loire",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1446,
  "estimated_value": 3396,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 208,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "270€",
  "_1": "0,07€"
}, {
  "departement_name": "71 - Saône- et- Loire",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1928,
  "estimated_value": 4528,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 278,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "360€",
  "_1": "0,07€"
}, {
  "departement_name": "72 - Sarthe",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 491,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 71,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "72 - Sarthe",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 982,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 141,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "72 - Sarthe",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1474,
  "estimated_value": 3396,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 212,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "270€",
  "_1": "0,07€"
}, {
  "departement_name": "72 - Sarthe",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1965,
  "estimated_value": 4528,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 283,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "360€",
  "_1": "0,07€"
}, {
  "departement_name": "73 - Savoie",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 462,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 67,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "73 - Savoie",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 925,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 133,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "73 - Savoie",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1387,
  "estimated_value": 3270,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 200,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "260€",
  "_1": "0,07€"
}, {
  "departement_name": "73 - Savoie",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1850,
  "estimated_value": 4276,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 266,
  "kwh_network": "0,1821",
  "rentabilite": "6,3",
  "": "340€",
  "_1": "0,07€"
}, {
  "departement_name": "74 - Haute- Savoie",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 485,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 70,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "74 - Haute- Savoie",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 970,
  "estimated_value": 2264,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 140,
  "kwh_network": "0,1821",
  "rentabilite": "6,2",
  "": "180€",
  "_1": "0,07€"
}, {
  "departement_name": "74 - Haute- Savoie",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1454,
  "estimated_value": 3396,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 209,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "270€",
  "_1": "0,07€"
}, {
  "departement_name": "74 - Haute- Savoie",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1939,
  "estimated_value": 4528,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 279,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "360€",
  "_1": "0,07€"
}, {
  "departement_name": "75 - Paris",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 447,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 64,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "75 - Paris",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 894,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 129,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "75 - Paris",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1340,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 193,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "75 - Paris",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1787,
  "estimated_value": 4151,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 257,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "330€",
  "_1": "0,08€"
}, {
  "departement_name": "76 - Seine- Maritime",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 442,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 64,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "76 - Seine- Maritime",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 885,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 127,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "76 - Seine- Maritime",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1327,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 191,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "76 - Seine- Maritime",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1770,
  "estimated_value": 4151,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 255,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "330€",
  "_1": "0,08€"
}, {
  "departement_name": "77 - Seine- et- Marne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 444,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 64,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "77 - Seine- et- Marne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 887,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 128,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "77 - Seine- et- Marne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1331,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 192,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "77 - Seine- et- Marne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1774,
  "estimated_value": 4151,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 256,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "330€",
  "_1": "0,08€"
}, {
  "departement_name": "78 - Yvelines",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 447,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 64,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "78 - Yvelines",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 894,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 129,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "78 - Yvelines",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1340,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 193,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "78 - Yvelines",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1787,
  "estimated_value": 4151,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 257,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "330€",
  "_1": "0,08€"
}, {
  "departement_name": "79 - Deux- Sèvres",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 528,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 76,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "79 - Deux- Sèvres",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1056,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 152,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,07€"
}, {
  "departement_name": "79 - Deux- Sèvres",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1584,
  "estimated_value": 3648,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 228,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "290€",
  "_1": "0,06€"
}, {
  "departement_name": "79 - Deux- Sèvres",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2112,
  "estimated_value": 4905,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 304,
  "kwh_network": "0,1821",
  "rentabilite": "5,5",
  "": "390€",
  "_1": "0,06€"
}, {
  "departement_name": "08 - Ardennes",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 429,
  "estimated_value": 1006,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 62,
  "kwh_network": "0,1821",
  "rentabilite": "7,4",
  "": "80€",
  "_1": "0,09€"
}, {
  "departement_name": "08 - Ardennes",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 858,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 123,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "08 - Ardennes",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1286,
  "estimated_value": 3019,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 185,
  "kwh_network": "0,1821",
  "rentabilite": "6,8",
  "": "240€",
  "_1": "0,08€"
}, {
  "departement_name": "08 - Ardennes",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1715,
  "estimated_value": 4025,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 247,
  "kwh_network": "0,1821",
  "rentabilite": "6,7",
  "": "320€",
  "_1": "0,08€"
}, {
  "departement_name": "80 - Somme",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 418,
  "estimated_value": 1006,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 60,
  "kwh_network": "0,1821",
  "rentabilite": "7,4",
  "": "80€",
  "_1": "0,09€"
}, {
  "departement_name": "80 - Somme",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 836,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 120,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "80 - Somme",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1254,
  "estimated_value": 2893,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 181,
  "kwh_network": "0,1821",
  "rentabilite": "7,1",
  "": "230€",
  "_1": "0,08€"
}, {
  "departement_name": "80 - Somme",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1672,
  "estimated_value": 3899,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 241,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "310€",
  "_1": "0,08€"
}, {
  "departement_name": "81 - Tarn",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 549,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 79,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "81 - Tarn",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1098,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 158,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,06€"
}, {
  "departement_name": "81 - Tarn",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1646,
  "estimated_value": 3773,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 237,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "300€",
  "_1": "0,06€"
}, {
  "departement_name": "81 - Tarn",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2195,
  "estimated_value": 5031,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 316,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "400€",
  "_1": "0,06€"
}, {
  "departement_name": "82 - Tarn- et- Garonne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 549,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 79,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "82 - Tarn- et- Garonne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1098,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 158,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,06€"
}, {
  "departement_name": "82 - Tarn- et- Garonne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1646,
  "estimated_value": 3773,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 237,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "300€",
  "_1": "0,06€"
}, {
  "departement_name": "82 - Tarn- et- Garonne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2195,
  "estimated_value": 5031,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 316,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "400€",
  "_1": "0,06€"
}, {
  "departement_name": "83 - Var",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 668,
  "estimated_value": 1635,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 96,
  "kwh_network": "0,1821",
  "rentabilite": "4,6",
  "": "130€",
  "_1": "0,06€"
}, {
  "departement_name": "83 - Var",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1336,
  "estimated_value": 3144,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 192,
  "kwh_network": "0,1821",
  "rentabilite": "4,4",
  "": "250€",
  "_1": "0,05€"
}, {
  "departement_name": "83 - Var",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 2004,
  "estimated_value": 4654,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 289,
  "kwh_network": "0,1821",
  "rentabilite": "4,4",
  "": "370€",
  "_1": "0,05€"
}, {
  "departement_name": "83 - Var",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2672,
  "estimated_value": 6163,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 385,
  "kwh_network": "0,1821",
  "rentabilite": "4,4",
  "": "490€",
  "_1": "0,05€"
}, {
  "departement_name": "84 - Vaucluse",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 614,
  "estimated_value": 1509,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 88,
  "kwh_network": "0,1821",
  "rentabilite": "5,0",
  "": "120€",
  "_1": "0,06€"
}, {
  "departement_name": "84 - Vaucluse",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1228,
  "estimated_value": 2893,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 177,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "230€",
  "_1": "0,06€"
}, {
  "departement_name": "84 - Vaucluse",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1842,
  "estimated_value": 4276,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 265,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "340€",
  "_1": "0,06€"
}, {
  "departement_name": "84 - Vaucluse",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2456,
  "estimated_value": 5660,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 354,
  "kwh_network": "0,1821",
  "rentabilite": "4,8",
  "": "450€",
  "_1": "0,05€"
}, {
  "departement_name": "85 - Vendée",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 535,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 77,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "85 - Vendée",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1070,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 154,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,07€"
}, {
  "departement_name": "85 - Vendée",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1604,
  "estimated_value": 3773,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 231,
  "kwh_network": "0,1821",
  "rentabilite": "5,4",
  "": "300€",
  "_1": "0,06€"
}, {
  "departement_name": "85 - Vendée",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2139,
  "estimated_value": 4905,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 308,
  "kwh_network": "0,1821",
  "rentabilite": "5,5",
  "": "390€",
  "_1": "0,06€"
}, {
  "departement_name": "86 - Vienne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 528,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 76,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "86 - Vienne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 1056,
  "estimated_value": 2516,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 152,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "200€",
  "_1": "0,07€"
}, {
  "departement_name": "86 - Vienne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1584,
  "estimated_value": 3648,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 228,
  "kwh_network": "0,1821",
  "rentabilite": "5,6",
  "": "290€",
  "_1": "0,06€"
}, {
  "departement_name": "86 - Vienne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 2112,
  "estimated_value": 4905,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 304,
  "kwh_network": "0,1821",
  "rentabilite": "5,5",
  "": "390€",
  "_1": "0,06€"
}, {
  "departement_name": "87 - Haute- Vienne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 500,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 72,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,07€"
}, {
  "departement_name": "87 - Haute- Vienne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 999,
  "estimated_value": 2390,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 144,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "190€",
  "_1": "0,07€"
}, {
  "departement_name": "87 - Haute- Vienne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1499,
  "estimated_value": 3522,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 216,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "280€",
  "_1": "0,07€"
}, {
  "departement_name": "87 - Haute- Vienne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1998,
  "estimated_value": 4654,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 288,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "370€",
  "_1": "0,07€"
}, {
  "departement_name": "88 - Vosges",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 436,
  "estimated_value": 1006,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 63,
  "kwh_network": "0,1821",
  "rentabilite": "7,4",
  "": "80€",
  "_1": "0,09€"
}, {
  "departement_name": "88 - Vosges",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 873,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 126,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "88 - Vosges",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1309,
  "estimated_value": 3019,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 189,
  "kwh_network": "0,1821",
  "rentabilite": "6,8",
  "": "240€",
  "_1": "0,08€"
}, {
  "departement_name": "88 - Vosges",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1746,
  "estimated_value": 4025,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 251,
  "kwh_network": "0,1821",
  "rentabilite": "6,7",
  "": "320€",
  "_1": "0,08€"
}, {
  "departement_name": "89 - Yonne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 495,
  "estimated_value": 1258,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 71,
  "kwh_network": "0,1821",
  "rentabilite": "6,0",
  "": "100€",
  "_1": "0,08€"
}, {
  "departement_name": "89 - Yonne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 990,
  "estimated_value": 2390,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 143,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "190€",
  "_1": "0,07€"
}, {
  "departement_name": "89 - Yonne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1484,
  "estimated_value": 3522,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 214,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "280€",
  "_1": "0,07€"
}, {
  "departement_name": "89 - Yonne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1979,
  "estimated_value": 4654,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 285,
  "kwh_network": "0,1821",
  "rentabilite": "5,8",
  "": "370€",
  "_1": "0,07€"
}, {
  "departement_name": "90 - Territoire- de- Belfort",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 436,
  "estimated_value": 1006,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 63,
  "kwh_network": "0,1821",
  "rentabilite": "7,4",
  "": "80€",
  "_1": "0,09€"
}, {
  "departement_name": "90 - Territoire- de- Belfort",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 873,
  "estimated_value": 2012,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 126,
  "kwh_network": "0,1821",
  "rentabilite": "6,9",
  "": "160€",
  "_1": "0,08€"
}, {
  "departement_name": "90 - Territoire- de- Belfort",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1309,
  "estimated_value": 3019,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 189,
  "kwh_network": "0,1821",
  "rentabilite": "6,8",
  "": "240€",
  "_1": "0,08€"
}, {
  "departement_name": "90 - Territoire- de- Belfort",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1746,
  "estimated_value": 4025,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 251,
  "kwh_network": "0,1821",
  "rentabilite": "6,7",
  "": "320€",
  "_1": "0,08€"
}, {
  "departement_name": "91 - Essonne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 447,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 64,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "91 - Essonne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 894,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 129,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "91 - Essonne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1340,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 193,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "91 - Essonne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1787,
  "estimated_value": 4151,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 257,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "330€",
  "_1": "0,08€"
}, {
  "departement_name": "92 - Hauts- de- Seine",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 447,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 64,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "92 - Hauts- de- Seine",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 894,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 129,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "92 - Hauts- de- Seine",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1340,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 193,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "92 - Hauts- de- Seine",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1787,
  "estimated_value": 4151,
  "price_ttc": 2696,
  "subscription_ttc": 6,
  "subscription_fees_ttc": 275,
  "planted_trees": 257,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "330€",
  "_1": "0,08€"
}, {
  "departement_name": "93 - Seine- St- Denis",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 447,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 64,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "93 - Seine- St- Denis",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 894,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 129,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "93 - Seine- St- Denis",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1340,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 193,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "93 - Seine- St- Denis",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1787,
  "estimated_value": 4151,
  "price_ttc": 2696,
  "subscription_ttc": 12,
  "subscription_fees_ttc": 550,
  "planted_trees": 257,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "330€",
  "_1": "0,08€"
}, {
  "departement_name": "94 - Val- de- Marne",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 447,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 64,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "94 - Val- de- Marne",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 894,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 129,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "94 - Val- de- Marne",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1340,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 193,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "94 - Val- de- Marne",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1787,
  "estimated_value": 4151,
  "price_ttc": 2696,
  "subscription_ttc": 18,
  "subscription_fees_ttc": 825,
  "planted_trees": 257,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "330€",
  "_1": "0,08€"
}, {
  "departement_name": "95 - Val- d'Oise",
  "panneau_count": 1,
  "centrale_name": "TESLA",
  "power": 400,
  "area": "2,0",
  "solar_production": 447,
  "estimated_value": 1132,
  "price_ttc": 749,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 64,
  "kwh_network": "0,1821",
  "rentabilite": "6,6",
  "": "90€",
  "_1": "0,08€"
}, {
  "departement_name": "95 - Val- d'Oise",
  "panneau_count": 2,
  "centrale_name": "WESTING",
  "power": 800,
  "area": "4,0",
  "solar_production": 894,
  "estimated_value": 2138,
  "price_ttc": 1398,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 129,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "170€",
  "_1": "0,08€"
}, {
  "departement_name": "95 - Val- d'Oise",
  "panneau_count": 3,
  "centrale_name": "EDISON",
  "power": 1200,
  "area": "6,0",
  "solar_production": 1340,
  "estimated_value": 3144,
  "price_ttc": 2047,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 193,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "250€",
  "_1": "0,08€"
}, {
  "departement_name": "95 - Val- d'Oise",
  "panneau_count": 4,
  "centrale_name": "FARADAY",
  "power": 1600,
  "area": "8,0",
  "solar_production": 1787,
  "estimated_value": 4151,
  "price_ttc": 2696,
  "subscription_ttc": 24,
  "subscription_fees_ttc": 1100,
  "planted_trees": 257,
  "kwh_network": "0,1821",
  "rentabilite": "6,5",
  "": "330€",
  "_1": "0,08€"
}];

function extractDepartementCode(str) {
  const regex = /^[0-9ab]{2}/gmi;
  var result = regex.exec(str);

  console.log(result);

  return result[0];
}

function checkHashToOpenConfigurator() {
  var hash = window.location.hash.replace('#', ''),
      dep = null;
  
  if(hash && (dep = extractDepartementCode(hash))) {
    showSimulator();
    process(hash);
  } else {
    closeConfigurator();
  }
}

function removeHash() { 
  history.pushState("", document.title, window.location.pathname + window.location.search);
}

function pushHash(hash) { 
  history.pushState("", document.title, window.location.pathname + window.location.search + hash);
}

function closeConfigurator() {
  $('[data-close-modal').click();
}

function process(departement_name) {
  var select_data_array = [];
  for(var i = 0; i < datas.length; i++) {
      if(extractDepartementCode(datas[i].departement_name) == extractDepartementCode(departement_name)) {
          select_data_array.push(datas[i]);
      }
  }
  
  console.log(select_data_array);
  
  var h = 0;
  
  for(var i = 5; i > 1; i--) {
      var j = i;
      console.log(h);
      var variant_block = $('[variant-index="' + j + '"]');
      variant_block.find('[data-intel="eco"]').html(select_data_array[h].estimated_value + " €");
      variant_block.find('[data-intel="prod"]').html(select_data_array[h].solar_production + "KWH");
      var estimated_value = parseInt(select_data_array[h].estimated_value);
      var price_ttc = parseInt(variant_block.attr("data-price") / 100);
      var f = price_ttc / (estimated_value / 10);
      variant_block.find('[data-intel="renta"]').html(select_data_array[h].rentabilite + " ANS");
      
      
      var width = $(window).width();
      if(width < 540) {
          $("#modalIntellisolar").animate({
              scrollTop: 450
          }, 1000);
      } else if(width >= 540 && width < 1024) {
          $("#modalIntellisolar").animate({
              scrollTop: 650
          }, 1000);
      } else {
          $("#modalIntellisolar").animate({
              scrollTop: 750
          }, 1000);
      }
      h = h + 1;
  }
  $(".modal-body").hide();
  $(".intellisolar-variants").show();
  setCarouselIntellisolar();
}

window.onpopstate = function(event) {
  checkHashToOpenConfigurator();
};

$(document).ready(function () {
  checkHashToOpenConfigurator();
  
  $(".get-eco").on("click", () => {
      var departement_name = $("#select-departement").val();
      process(departement_name);
      pushHash('#' + extractDepartementCode(departement_name));
  });

  $('[data-close-modal').on("click", () => {
    removeHash();
  });
  
  $(".intell-info").on("click", () => {
      $(".intellisolar-defs").show();
      $("#modalIntellisolar .modal-content-custom").animate({
          scrollTop: 900
      }, 1000);
  });
});

var intellisolarCarousel = false;

function setCarouselIntellisolar() {
  var width = $(window).width();
  
  if(width > 990) {
      if(intellisolarCarousel) {
          $('.intellisolar-variants__items').flickity('destroy');
          intellisolarCarousel = false;
      }
  } else {
      if(intellisolarCarousel == false) {
          console.log('flickity - go');
          $('.intellisolar-variants__items').flickity({
              wrapAround: true,
          });
          
          var tapArea, startX;
          tapArea = document.querySelectorAll('.intellisolar-variants__items');
          startX = 0;
          for(var item of tapArea) {
              item.ontouchstart = function (e) {
                  startX = e.touches[0].clientX;
              };
              item.ontouchmove = function (e) {
                  if(Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
                      e.preventDefault();
                  }
              };
          }
          
          
          $('.intellisolar-variants__items').flickity('select', 2, false, true);
          intellisolarCarousel = true;
      }
  }
}

$('[data-target="#modalIntellisolar"]').click(function () {
  setTimeout((function () {
      var touchingCarousel = false,
          touchStartCoords;
      
      document.body.addEventListener('touchstart', function (e) {
          if(e.target.closest('.flickity-slider')) {
              touchingCarousel = true;
          } else {
              touchingCarousel = false;
              return;
          }
          
          touchStartCoords = {
              x: e.touches[0].pageX,
              y: e.touches[0].pageY
          }
      });
      
      document.body.addEventListener('touchmove', function (e) {
          if(!(touchingCarousel && e.cancelable)) {
              return;
          }
          
          var moveVector = {
              x: e.touches[0].pageX - touchStartCoords.x,
              y: e.touches[0].pageY - touchStartCoords.y
          };
          
          if(Math.abs(moveVector.x) > 7)
              e.preventDefault()
          
      }, {
          passive: false
      });
  }, 3000));
  
});

$(window).resize(function () {
  $('[data-section-type="product-aio-icons-text"] h3').attr("style", "");
  $('[data-section-type="product-aio-icons-text"]').each(function () {
      var h = 0;
      var max_h = 0;
      $(this).find('h3').each(function () {
          h = $(this).height();
          if(h > max_h) {
              max_h = h;
          }
      });
      $(this).find('h3').height(max_h);
  });
});

$(document).ready(() => {
  $(".intellisolar-variants .productForm-submit").on('click', function () {
      setTimeout(() => {
          closeConfigurator();
      }, 1000);
  });
  
  $('.body--intellisolar-stockdrop a.productForm-submit').on('click', function () {
      $('.productForm-buttons .productForm-submit').click();
  });
  
  $('[data-section-type="product-aio-icons-text"] h3').attr("style", "");
  $('[data-section-type="product-aio-icons-text"]').each(function () {
      var h = 0;
      var max_h = 0;
      $(this).find('h3').each(function () {
          h = $(this).height();
          if(h > max_h) {
              max_h = h;
          }
      });
      $(this).find('h3').height(max_h);
  });
});
